import React from 'react'
import CourseLandingPage from '../../components/Courses/CourseLandingPage/CourseLandingPage'
import RevitBimCourse from '../../data/cad_section/RevitBimCourse'
import SEO from '../../components/common/seo/SEO'

function RevitAPIPage() {
  return (
    <>
    
     <SEO
        title="Revit API Customization & Automation Training | Revit API Course | FeesWorth"

        description="Learn Autodesk Revit API customization and automation using C# and .NET. Master Revit API, BIM automation, Revit add-in development, model automation, and practical Revit API projects with expert training at FeesWorth."

        keywords="Revit API Training, Revit API Course, Revit Customization Training, Revit Automation Training, Revit C# Training, Revit .NET API, Revit Add-in Development, Revit BIM Automation, Revit API Programming, Revit Automation Course"

        canonical="https://feesworth.com/autodesk-revit-api-customization-automation-course"
      />

    <CourseLandingPage course={RevitBimCourse}/>
    
    </>
  )
}

export default RevitAPIPage